module.exports = __webpack_public_path__ + "static/infrared-ad320eaf1b62b62635398530d122c041.png";